import { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import { useSearchParams } from "react-router-dom";

export default function CompleteSignup() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [fullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignup = async () => {
    if (!token) return alert("Invalid invite token.");
    if (!fullName) return alert("Enter your name.");

    setLoading(true);

    try {
      // 1️⃣ Get the invite from DB
      const { data: invite, error: inviteError } = await supabase
        .from("coach_invites")
        .select("*")
        .eq("token", token)
        .single();

      if (inviteError || !invite) {
        alert("Invalid or expired invite.");
        setLoading(false);
        return;
      }

      // 2️⃣ Get the auth user by email
      const { data: { user }, error: userError } = await supabase.auth.getUserByEmail(invite.email);
      if (userError || !user) {
        alert("Please use the magic link sent to your email to sign up.");
        setLoading(false);
        return;
      }

      // 3️⃣ Update your users table with role & program
      const { error: updateError } = await supabase
        .from("users")
        .update({
          full_name: fullName,
          role: "coach",
          program_id: invite.program_id
        })
        .eq("id", user.id);

      if (updateError) throw updateError;

      // 4️⃣ Add the user to program_coaches table
      const { error: coachError } = await supabase
        .from("program_coaches")
        .insert([{
          user_id: user.id,
          program_id: invite.program_id,
          role: invite.role || "Assistant Coach", // fallback role
          team_id: invite.team_id || null
        }]);

      if (coachError) throw coachError;

      // 5️⃣ Mark invite as accepted
      await supabase
        .from("coach_invites")
        .update({ accepted: true })
        .eq("id", invite.id);

      alert("Welcome! You are now a coach.");
    } catch (err) {
      console.error("Signup failed:", err);
      alert("Error completing signup: " + err.message);
    }

    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto mt-20">
      <h1 className="text-2xl font-bold mb-4">Complete Your Signup</h1>
      <input
        type="text"
        placeholder="Full Name"
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        className="w-full p-2 border rounded mb-4"
      />
      <button
        onClick={handleSignup}
        className="w-full p-2 bg-blue-600 text-white rounded"
        disabled={loading}
      >
        {loading ? "Completing Signup..." : "Complete Signup"}
      </button>
    </div>
  );
}
